import React, {useLayoutEffect, useRef} from 'react';
import {Box, VStack} from '@chakra-ui/react';

/** Keep the latest message visible until the reader scrolls back in history. */
export default function ConversationMessages({children}: {children: React.ReactNode}) {
  const viewport = useRef<HTMLDivElement>(null);
  const content = useRef<HTMLDivElement>(null);
  const following = useRef(true);
  const followLatest = () => {
    if (following.current && viewport.current) viewport.current.scrollTop = viewport.current.scrollHeight;
  };

  useLayoutEffect(() => {
    followLatest();
    // Photos and expanded descriptions can change height after the thread loads.
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(followLatest);
    if (content.current) observer.observe(content.current);
    if (viewport.current) observer.observe(viewport.current);
    return () => observer.disconnect();
  }, []);

  useLayoutEffect(followLatest, [children]);

  return <Box ref={viewport} flex="1" minH={0} overflowY="auto" p={4}
    sx={{overflowAnchor:'none'}} aria-label="Conversation messages"
    onScroll={event => {
      const element = event.currentTarget;
      following.current = element.scrollHeight - element.clientHeight - element.scrollTop <= 60;
    }}>
    <VStack ref={content} spacing={2} align="stretch">{children}</VStack>
  </Box>;
}
